import styled, { css, DefaultTheme } from 'styled-components';

import { BaseInputProps, SizeType } from './BaseInputTypes';

function sizeMapping(size: SizeType, theme: DefaultTheme) {
  const sizeMap = {
    small: theme.spacing.km2,
    medium: `${theme.spacing.km2}px ${theme.spacing.km3}px`,
    large: `${theme.spacing.km4}px`,
  };

  return sizeMap[size];
}

const BaseInput = styled.input<BaseInputProps>`
  background: ${({ theme }) => theme.color.background.neutral.default};
  border: ${({ theme }) => theme.border.width.thinner} solid
    ${({ theme }) => theme.color.border.neutral.default};
  border-radius: ${({ theme }) => theme.border.radius.medium};
  padding: ${({ theme, $inputSize = 'medium' }) =>
    sizeMapping($inputSize, theme)};
  font-size: ${({ theme }) => theme.font.size.m3};
  width: 100%;
  color: ${({ theme }) => theme.color.text.neutral.default};

  ${({ $variant }) =>
    $variant === 'filled' &&
    css`
      background: ${({ theme }) => theme.color.background.neutral.default};
      border-color: ${({ theme }) => theme.color.border.neutral.strong};
    `}

  ${({ $variant }) =>
    $variant === 'success' &&
    css`
      background: ${({ theme }) => theme.color.background.neutral.default};
      border-color: ${({ theme }) => theme.color.border.success};
    `}

  ${({ $variant }) =>
    $variant === 'error' &&
    css`
      background: ${({ theme }) => theme.color.background.neutral.default};
      border-color: ${({ theme }) => theme.color.border.danger.default};
    `}

  &:focus {
    background: ${({ theme }) => theme.color.background.neutral.weak};
    border-color: ${({ theme }) => theme.color.border.neutral.strong};
  }

  &:disabled {
    background: ${({ theme }) => theme.color.background.neutral.default};
    border-color: ${({ theme }) => theme.color.border.neutral.default};
    color: ${({ theme }) => theme.color.text.neutral.weak};
  }
`;

export default BaseInput;
